import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function GetAQuote() {
    return (

        <div className="inner-page">

            <Header />


            <div className="rts-breadcrumb-area bg_image">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="baread-crumb-main-wrapper pt--100">
                                <div className="inner">
                                    <h1 className="title rts_hero__title">Get a quote</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="appoinmnet-area-two rts-section-gapBottom bg-white pt--100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            
                            <div className="appoinment-area-two plr--120 plr_sm--20 plr_md--20">
                                <div className="title-area-appoinment">
                                    <span className="pre">Appointment</span>
                                    <h2 className="title quote mb--0">
                                        Love to hear from you <br/>
                                    </h2>
                                    <h2 className="title quote">
                                        <span>Get in touch!</span>
                                    </h2>
                                </div>
                                <form className="appoinment-h2 rts-slide-up-gsap" action="#">
                                    <div className="input-line">
                                        <div className="input-half">
                                            <label for="name">Your Name*</label>
                                            <input id="name" type="text" placeholder="Enter Your Name...." required/>
                                        </div>
                                        <div className="input-half">
                                            <label for="email">Your Email*</label>
                                            <input id="email" type="text" placeholder="Enter Your Mail...."/>
                                        </div>
                                    </div>
                                    <div className="input-line mt--40">
                                        <div className="input-half">
                                            <label for="name">What you are interested*</label>
                                            <select className="form-select" aria-label="Default select example">
                                            <option selected    >select your interesting</option>
                                                <option value="1">Website Development</option>
                                                <option value="2">App Development</option>
                                                <option value="3">Ecommerce Development</option>
                                                <option value="4">Digital Marketing</option>
                                                <option value="5">SEO</option>
                                                <option value="6">Graphic Designing</option>
                                            </select>
                                        </div>
                                        <div className="input-half">
                                            <label for="email">Project Budget*</label>
                                            <select className="form-select" aria-label="Default select example">
                                                <option selected>Design & Branding</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="text-area mt--40">
                                        <label for="message">Message*</label>
                                        <textarea id="message" cols="30" rows="10"
                                            placeholder="Let tell us about your projects"></textarea>
                                        <button type="submit" className="rts-btn btn-subnit-h2">Send Message</button>
                                    </div>
                                </form>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>

            <Footer />

            <div className="loading-screen" id="loading-screen">
                <span className="bar top-bar"></span>
                <span className="bar down-bar"></span>
                <span className="progress-line"></span>
                <span className="loading-counter"> </span>
            </div>


            <div className="bg-noise"></div>


           
            <div className="progress-wrap">
                <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
                    <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"></path>
                </svg>
            </div>
           
            <div className="rts-cursor cursor-outer" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor"></span>
            </div>
            <div className="rts-cursor cursor-inner" data-default="yes" data-link="yes" data-slider="no">
                <span className="fn-cursor">
                    <span className="fn-left"></span>
                    <span className="fn-right"></span>
                </span>
            </div>
           
            <div className="modal-sidebar-scroll rts-dark-light">
                <ul>
                    <li className="go-dark-w"><span>Dark</span><i className="rts-go-dark fal fa-moon"></i></li>
                    <li className="go-light-w"><span>Light</span><i className="rts-go-light fa-light fa-brightness"></i></li>
                </ul>
            </div>
           
    </div >
  )
}

export default GetAQuote
